<template lang="pug">
  v-card.mt-3.px-3(color="success" dark width="100%" height="100%"  )
    v-row(justify="center")
      v-col(cols="12" md="6")
        .body-1.font-weight-black(v-if="select !== 'Select An Interview'") Now Playing
        v-menu
          template(v-slot:activator='{ on, attrs }')
            v-btn.btnText(:color="select !='Select An Interview'? 'primary': 'black'"  v-bind='attrs' v-on='on') {{select}}
          v-list(dense)
            v-list-item(v-for="item in file" :key="item.title" @click='setAudio(item)')
              v-list-item-content {{item.title}}
      v-col(cols="12" md="6")
        vue-audio(:file="theAudio")
</template>

<script>
import VueAudio from 'vue-audio';
export default {
  name: 'audio-player',
  components: {
    'vue-audio': VueAudio
  },
  data() {
    return {
      theAudio: this.audio,
      isplaying: false,
      select: 'Select An Interview',
      file: [
        {
          title: 'Our Common Christ',
          file: require('../../assets/audio/interview1.mp3')
        },
        {
          title: 'A Very Vigorous Welcome',
          file: require('../../assets/audio/interview2.mp3')
        },
        {
          title: 'Righting a Fundamentalist Wrong',
          file: require('../../assets/audio/interview3.mp3')
        },
        {
          title: 'An Openness to Our Otherness',
          file: require('../../assets/audio/interview4.mp3')
        },
        {
          title: 'The Cross Section that Exists',
          file: require('../../assets/audio/interview5.mp3')
        },
        {
          title: 'Get Inside the Gate',
          file: require('../../assets/audio/interview6.mp3')
        }
      ]
    };
  },
  // computed: {
  //   theDuration() {
  //     let d = this.theAudio.duration;
  //     console.log('TCL: theDuration -> d', typeof d);
  //     return d;
  //   },
  //   theCurrentTime() {
  //     return this.theAudio.currentTime;
  //   }
  // },
  methods: {
    setAudio(theAudio) {
      this.theAudio = theAudio.file;
      this.select = theAudio.title;
    }
  }
};
</script>

<style lang="stylus" scoped>
// span.v-btn__content
//   font-size 10px !important

.duration
  color #fff

.vue-sound-wrapper .vue-sound__player .vue-sound__playback-time-wrapper[data-v-4d4f1e62]
  max-width 50% !important

@media only screen and (max-width: 950px)
  [class*='col-']
    width 100%

  .btnText
    font-size 10px
</style>
